import { inarixColors } from "inarix-theme";

export const SwitchesStyles = {
  SwitchesButton: {
    textTransform: "none",
    background: inarixColors.contrast_inarix,
    borderColor: "#C0C0C0",
    "&:hover": {
      backgroundColor: inarixColors.action_hover_inarix,
      border: `solid 0.5px #000`,
      boxShadow: "none",
    },
  },
  Menu: {
    width: "100%",
    gap: "24px",
  },
  FormControl: {
    width: "100%",
    height: "100%", // Take full height of parent
    display: "flex",
    flexDirection: "column",
    overflow: "hidden", // Prevent FormControl from scrolling
  },

  TextField: {
    width: "100%",
    marginBottom: "20px",
    fontStyle: "italic",
  },

  Button: {
    textTransform: "none",
  },
  FormGroup: {
    width: "100%",
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "column", // Ensure vertical layout
    overflow: "visible", // Prevent creating its own scroll context
  },

  DataTableBox: {
    height: 500,
    width: 1,
    marginLeft: "40px",
  },
  iconStyle: {
    fontSize: 16,
    color: "#666",
  },
  buttonsContainer: {
    display: "flex",
    gap: "8px",
    marginBottom: "16px",
  },
  switchesContainer: {
    maxHeight: "calc(100vh - 300px)", // Dynamic height based on viewport
    overflowY: "auto",
    overflowX: "hidden", // Prevent horizontal scroll
    scrollbarWidth: "thin", // For Firefox
    paddingRight: "12px", // Add space for scrollbar and icons
    marginRight: "-6px", // Compensate for the padding
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#c1c1c1",
      borderRadius: "3px",
      "&:hover": {
        background: "#a8a8a8",
      },
    },
  },
  circularProgressContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  },
  formControlLabel: {
    borderBottom: "1px solid #eee",
    marginLeft: "0px",
    marginRight: "0px",
    justifyContent: "space-between",
    padding: "8px 16px 8px 0", // Extra padding on the right for icons
    minHeight: "auto", // Prevent unnecessary height
    flexShrink: 0, // Prevent shrinking in flex container
    width: "100%", // Ensure full width usage
  },
  switchContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
};
